export const formatTimeAgo = (dateString: string, t: any) => {
  // Если сервер отдает локальное время с 'Z', нужно добавить offset
  const utcDate = new Date(dateString);
  if (Number.isNaN(utcDate.getTime())) {
    return '';
  }
  const date = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInDays > 0) {
    // Manually format for proper Russian/English display
    const template = t('proposals.timeAgo.daysHours');
    return template
      .replace('{{days}}', diffInDays.toString())
      .replace('{{hours}}', (diffInHours % 24).toString());
  }

  if (diffInHours > 0) {
    const template = t('proposals.timeAgo.hours');
    return template.replace('{{hours}}', diffInHours.toString());
  }

  if (diffInMinutes > 0) {
    const template = t('proposals.timeAgo.minutes');
    return template.replace('{{minutes}}', diffInMinutes.toString());
  }

  return t('proposals.timeAgo.justNow');
};
export const formatDate = (dateString: string) => {
  const utcDate = new Date(dateString);
  if (Number.isNaN(utcDate.getTime())) {
    return '';
  }
  const date = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${hours}:${minutes}, ${day}.${month}.${year}`;
};
